import { render, staticRenderFns } from "./comp-info.vue?vue&type=template&id=10e4fb42&scoped=true&lang=pug&"
import script from "./comp-info.vue?vue&type=script&lang=js&"
export * from "./comp-info.vue?vue&type=script&lang=js&"
import style0 from "./comp-info.vue?vue&type=style&index=0&id=10e4fb42&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10e4fb42",
  null
  
)

export default component.exports